import type {
  DataItem,
  StatItem,
  AttributeType,
  SubjectType,
  ColorsModel
} from '@aytm/app/insights/dashboard/models/types.ClientDTO'

import { ItemListModel } from '@aytm/app/insights/dashboard/models/BlockModel'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { getCurrentMethod } from '@aytm/app/insights/dashboard/helpers/attributes'

export type StateSelectorParams = {
  items: ItemListModel | null
  data: Record<string, DataItem | string>
  stat: Record<string, StatItem | string>
  subjects: Record<string, SubjectType>
  attributes: Record<string, AttributeType>
  sortByAttribute: string | null
  showSigtest: boolean
  showImages: boolean
  currentMethod: string | null
  currentSplit: string | null
  colors: ColorsModel
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const items = block?.getBlockItems()
  const data = state.currentData?.data || {}
  const stat = state.currentData?.stat || {}
  const subjects = state.currentData?.subjects || {}
  const attributes = state.currentData?.attributes || {}
  const sortByAttribute = block?.get<string>('sortByAttribute') || null
  const colors = block?.get<ColorsModel>('colors') || null
  const currentSplit = block?.get<string>('currentSplit') || null
  const showSigtest = block?.get<boolean>('showSigtest') || false
  const showImages = block?.get<boolean>('showImages')
  const currentMethod = getCurrentMethod(state)
  return {
    items,
    data,
    stat,
    subjects,
    attributes,
    sortByAttribute,
    showSigtest,
    showImages,
    currentMethod,
    currentSplit,
    colors
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : prev.data !== next.data ||
      prev.stat !== next.stat ||
      prev.colors !== next.colors ||
      prev.items !== next.items ||
      prev.subjects !== next.subjects ||
      prev.attributes !== next.attributes ||
      prev.sortByAttribute !== next.sortByAttribute ||
      prev.showSigtest !== next.showSigtest ||
      prev.showImages !== next.showImages ||
      prev.currentMethod !== next.currentMethod ||
      prev.currentSplit !== next.currentSplit
